import { PaperlessActionTypes } from "./actions";

export const initialState = {
  paperlessAccounts: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PaperlessActionTypes.FETCH_PAPERLESS_SETTINGS_USER.SUCCESS: {
      return {
        ...state,
        paperlessAccounts: action.payload.data,
      };
    }
    case PaperlessActionTypes.FETCH_ACCOUNT_PAPERLESS_SETTINGS_USER.SUCCESS: {
      return {
        ...state,
        paperlessAccounts: state.paperlessAccounts.map(paperlessAccount => {
          if (paperlessAccount.account === action.payload.data.account) {
            return {
              ...paperlessAccount,
              ...action.payload.data,
            };
          }

          return paperlessAccount;
        }),
      };
    }
    case PaperlessActionTypes.PAPERLESS_TRADE_OPTIONS_OUT.SUCCESS: {
      return {
        ...state,
        paperlessAccounts: state.paperlessAccounts.map(account => ({
          ...account,
          paperlessState: false,
        })),
      };
    }

    case PaperlessActionTypes.SAVE_PAPERLESS_SETTINGS.SUCCESS: {
      return {
        ...state,
        paperlessAccounts: state.paperlessAccounts.map(paperlessAccount => {
          const account = (action.payload?.data || []).find(
            ({ account }) => account === paperlessAccount.accountNumber
          );

          if (account) {
            return {
              ...paperlessAccount,
              paperlessDate: account.effectiveDate,
            };
          }

          return paperlessAccount;
        }),
      };
    }

    default:
      return state;
  }
};
